import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const QuoteToDeliveryRoute: RouteType = {
  name: "Quote to Delivery",
  path: "/purchasing/quote-to-delivery",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  hidden: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Quote to Delivery Conversion",
      component: () => import("./QuoteToDeliveryHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./QuoteToDeliveryBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const quotesStore = rootStore.quotesStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const jobsStore = rootStore.jobStore as ServiceStore;

      if (quotesStore) {
        await quotesStore.find();
      }

      if (productsStore) {
        await productsStore.find();
      }

      if (jobsStore) {
        await jobsStore.find({ query: { $limit: 50 } });
      }

      return true;
    } catch (error) {
      console.error("Failed to load data for quote to delivery:", error);
      return true;
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).quoteToDeliveryViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default QuoteToDeliveryRoute;
